import React, { useState } from "react";
import GridItem from "./GridItem";
import {
  Chevron,
  ChildRow,
  GridContainer,
  HeaderItem,
  Item,
} from "./EditableGridStyles";

const EditableGrid = (props) => {
  const { cols, rows, groupedRows, hideHeader } = props;
  const [activeRows, setActiveRows] = useState([]);

  function handleActive(index) {
    let newActiveRows = [...activeRows];
    if (newActiveRows.includes(index)) {
      newActiveRows = newActiveRows.filter((item) => item !== index);
    } else {
      newActiveRows.push(index);
    }
    setActiveRows(newActiveRows);
  }

  const isOdd = (num) => num % 2;

  const gridCols = cols
    .map(({ colSize }) => (colSize ? `${colSize}fr` : "1fr"))
    .join(" ");

  return (
    <GridContainer gridCols={gridCols} groupedRows={groupedRows}>
      {!hideHeader && (
        <>
          {groupedRows && <HeaderItem />}
          {cols.map((col, i) => (
            <HeaderItem key={`header_${i}`}>{col.headerName}</HeaderItem>
          ))}
        </>
      )}
      {rows.map((row, rowIndex) => {
        const arrow = groupedRows && (
          <Item key={`arrow_${rowIndex}`} isOdd={isOdd(rowIndex)}>
            <Chevron
              onClick={() => handleActive(rowIndex)}
              active={activeRows.includes(rowIndex)}
            >
              &#8250;
            </Chevron>
          </Item>
        );

        const arr = cols.map((col, colIndex) => (
          <GridItem
            key={`gridItem_${rowIndex}_${colIndex}`}
            isOdd={isOdd(rowIndex)}
            value={row.fields[col.field]}
            editable={typeof col.editable === 'function' ? col.editable({col,row}) : col.editable}
            onChange={col.onChange ? (e) => col.onChange({value: e.target.value, row,col,rowIndex,colIndex}) : null}
            formatVal={col.formatVal}
            row={row}
            col={col}
            inputType={row.inputType}
          >
            {col.comp &&
              col.comp({ ...row.data, cellValue: row.fields[col.field] })}
          </GridItem>
        ));

        const child = activeRows.includes(rowIndex) && (
          <ChildRow
            key={`childRow_${rowIndex}`}
            length={groupedRows ? cols.length + 1 : cols.length}
          >
            <div>
              {row.children && <EditableGrid cols={row.children.cols} rows={row.children.rows} />}
              {row.childComp && <div style={{background:'#fff'}}>{row.childComp}</div>}
            </div>
          </ChildRow>
        );

        return [arrow, ...arr, child];
      })}
    </GridContainer>
  );
};

export default EditableGrid;
